var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiVoiceCircles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 175,
    viewBox: "0 0 181 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3706,
    cy: 87.0441,
    rx: 90.3706,
    ry: 87.0441,
    fill: "#FFC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3711 0.554688C139.995 0.554942 180.186 39.2967 180.187 87.0439C180.187 134.791 139.995 173.534 90.3711 173.534C40.7472 173.534 0.554688 134.791 0.554688 87.0439C0.554769 39.2965 40.7473 0.554688 90.3711 0.554688Z",
    stroke: "#FCA2A2",
    strokeOpacity: 0.2,
    strokeWidth: 1.10884
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3706,
    cy: 87.0441,
    rx: 90.3706,
    ry: 87.0441,
    fill: "#FFC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3711 0.554688C139.995 0.554942 180.186 39.2967 180.187 87.0439C180.187 134.791 139.995 173.534 90.3711 173.534C40.7472 173.534 0.554688 134.791 0.554688 87.0439C0.554769 39.2965 40.7473 0.554688 90.3711 0.554688Z",
    stroke: "#FCA2A2",
    strokeOpacity: 0.2,
    strokeWidth: 1.10884
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.2022,
    cy: 87.0041,
    rx: 78.6871,
    ry: 75.4884,
    fill: "#FBA698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2026 12.0703C133.376 12.0705 168.334 45.6407 168.334 87.0039C168.334 128.367 133.376 161.938 90.2026 161.938C47.0292 161.938 12.0698 128.367 12.0698 87.0039C12.0699 45.6405 47.0293 12.0703 90.2026 12.0703Z",
    stroke: "#FCA2A2",
    strokeOpacity: 0.2,
    strokeWidth: 1.10884
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.202,
    cy: 87.0043,
    rx: 65.8924,
    ry: 62.6938,
    fill: "#EB9183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2021 24.8652C126.313 24.8653 155.54 52.7112 155.54 87.0039C155.54 121.297 126.314 149.143 90.2021 149.144C54.0906 149.144 24.8643 121.297 24.8643 87.0039C24.8645 52.7112 54.0908 24.8652 90.2021 24.8652Z",
    stroke: "#FCA2A2",
    strokeOpacity: 0.2,
    strokeWidth: 1.10884
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiVoiceCircles);
export default __webpack_public_path__ + "static/media/AIVoiceCircles.489147bf6608cd3ae12b7cff93f4658f.svg";
export { ForwardRef as ReactComponent };